// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { EventType, EventSource, TradingEventType } from './EventConstants';
import { EventDescriptionItem } from './EventDescriptionItem';
import { DataCache } from '../../DataCache';
export class Event {
    constructor(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        this.DescriptionItems = [];
        this.Account = (_a = params.Account) !== null && _a !== void 0 ? _a : '';
        this.Action = (_b = params.Action) !== null && _b !== void 0 ? _b : '';
        this.EventType = (_c = params.EventType) !== null && _c !== void 0 ? _c : EventType.None;
        this.Source = (_d = params.EventSource) !== null && _d !== void 0 ? _d : EventSource.None;
        this.DateTime = (_e = params.DateTime) !== null && _e !== void 0 ? _e : DateTimeUtils.DateTimeUtcNow();
        this.timestamp = this.DateTime.getTime();
        this.Id = Event.GeneratedId++;
        this.InstrumentTradableID = (_g = (_f = params.Instrument) === null || _f === void 0 ? void 0 : _f.InstrumentTradableID) !== null && _g !== void 0 ? _g : null;
        this.RouteID = (_j = (_h = params.Instrument) === null || _h === void 0 ? void 0 : _h.Route) !== null && _j !== void 0 ? _j : null;
        this.ProductType = (_k = params.ProductType) !== null && _k !== void 0 ? _k : null;
        this.Roundtrip = (_l = params.Roundtrip) !== null && _l !== void 0 ? _l : 0;
        this.BusinessRejectCode = (_m = params.BusinessRejectCode) !== null && _m !== void 0 ? _m : -1;
        if (Array.isArray(params.Description)) {
            // events from indexedDB
            this.DescriptionItems = params.Description.map((item) => new EventDescriptionItem(item.Header, item.Value));
        }
        else {
            this.ParseEventDescriptionItems(params.Description);
        }
    }
    ParseEventDescriptionItems(msg) {
        if (!msg)
            return;
        this.DescriptionItems = [];
        if (this.EventType === EventType.Comment) {
            this.DescriptionItems.push(new EventDescriptionItem(msg, ''));
            return;
        }
        if (this.EventType === EventType.Trading && this.Source === EventSource.Refused) // Alert Event Msg Parsing
         {
            this.DescriptionItems.push(new EventDescriptionItem('Refused', msg.split('Error:')[1].split(';')[0]));
            return;
        }
        const ins = DataCache.getInstrumentByTradable_ID(this.InstrumentTradableID, this.RouteID);
        const hideRoute = ins ? ins.isHideRouteMode : false;
        if (typeof msg === 'string') {
            const splits = msg.split(';');
            const len = splits.length;
            for (let i = 0; i < len; i++) {
                const split = splits[i];
                if (!split)
                    continue;
                const item = new EventDescriptionItem();
                const headerValueArr = split.split(':');
                item.Header = headerValueArr[0];
                item.Value = headerValueArr[1] || '';
                for (let j = 2; j < headerValueArr.length; j++) {
                    item.Value += ':' + headerValueArr[j];
                }
                if (item.Header === 'Route' && hideRoute) {
                    continue;
                }
                // Тики в строку
                switch (item.Header) {
                    case 'Time':
                    case 'DateTime':
                    case 'SettleDate':
                        const millis = parseFloat(item.Value);
                        item.Value = new Date(isNaN(millis) ? item.Value : millis);
                        break;
                }
                this.DescriptionItems.push(item);
            }
        }
    }
    GetFormattedDescription() {
        let resultStr = '';
        const descriptionItems = this.DescriptionItems;
        const len = descriptionItems.length;
        for (let i = 0; i < len; i++) {
            const descriptionItem = descriptionItems[i];
            const localizedHeader = descriptionItem.Header;
            const localizedValue = descriptionItem.Value ? descriptionItem.Value.toString() : '';
            if (localizedValue) {
                resultStr += localizedHeader + ':' + localizedValue + '; ';
            }
            else {
                resultStr += localizedHeader;
            }
        }
        return resultStr;
    }
    GetTradingEventType() {
        const action = this.Action.toLowerCase();
        if (this.Source === EventSource.MarginCall) {
            return TradingEventType.MarginCall;
        }
        else if (action.indexOf('request') !== -1) {
            return TradingEventType.Request;
        }
        else if (this.Source === EventSource.Refused ||
            action.indexOf('refuse') !== -1 ||
            action.indexOf('reject') !== -1 ||
            action.indexOf('trading disabled') !== -1) {
            return TradingEventType.Reject;
        }
        else if (action.indexOf('fill') !== -1) {
            return TradingEventType.Fill;
        }
        else if (action.indexOf('create') !== -1) {
            return TradingEventType.Create;
        }
        else if (action.indexOf('modif') !== -1) // modify/modified
         {
            return TradingEventType.Modify;
        }
        else if (action.indexOf('remove') !== -1) {
            return TradingEventType.Remove;
        }
        // все остальные трейдинговые - это реквесты, все вопросы по раскраске к андрею
        else if (this.EventType === EventType.Trading) {
            return TradingEventType.Request;
        }
        return TradingEventType.NotTrading;
    }
}
Event.GeneratedId = 0;
